
import LogoMksp from "../logoMksp/LogoMksp"

export default function Footer() {
    return (
        <>
        {/* Footer */}
        <footer className="p-4 bg-white md:p-8 lg:p-10 dark:bg-gray-900">
          <div className="mx-auto max-w-screen-xl text-center">
            <div className="flex mb-10 justify-center items-center text-2xl font-semibold text-gray-900 dark:text-white">
              <LogoMksp/>
            </div>
            
            <span className="text-sm text-gray-500 sm:text-center dark:text-gray-400">© 2025-2026 <a href="/" className="hover:underline">Msp</a>. All Rights Reserved.</span>
          </div>
        </footer>
        </>
    )
}